import type { CountyStatePair, PipelineTapGateResolution } from '@buxus/shared'

type PipelineTapDenyReason = Extract<PipelineTapGateResolution, { allowed: false }>['reason']

function messageForReason(reason: PipelineTapDenyReason): string {
  switch (reason) {
    case 'no_jurisdiction_match':
      return 'This pipeline segment is outside of your registered jurisdiction. Detailed pipeline information is not available here.'
    case 'no_profile_keys':
      return 'Your profile does not include jurisdiction access required to view pipeline details at this location.'
    case 'no_county_state':
      return 'We could not verify the location of this tap. Pipeline details are not shown.'
  }
}

function formatLocationLabel(geoPairs: readonly CountyStatePair[]): string | null {
  if (!geoPairs.length) return null
  return geoPairs.map((pair) => `${pair.county}, ${pair.state}`).join(' · ')
}

type MapPipelineJurisdictionDeniedBubbleProps = {
  reason: PipelineTapDenyReason
  geoPairs: readonly CountyStatePair[]
  showLocation: boolean
  onClose: () => void
}

export function MapPipelineJurisdictionDeniedBubble({
  reason,
  geoPairs,
  showLocation,
  onClose,
}: MapPipelineJurisdictionDeniedBubbleProps) {
  const location = showLocation ? formatLocationLabel(geoPairs) : null

  return (
    <div
      className="map-pipeline-popup map-pipeline-popup--jurisdiction-denied"
      role="dialog"
      aria-label="Pipeline segment unavailable"
    >
      <div className="map-pipeline-popup-content">
        <p className="map-pipeline-popup-restricted-lead">Pipeline Details Unavailable</p>
        <p className="map-pipeline-popup-restricted-message">{messageForReason(reason)}</p>
        {location ? (
          <p className="map-pipeline-popup-restricted-location">
            <span className="map-pipeline-popup-restricted-location-label">Area:</span> {location}
          </p>
        ) : null}
      </div>
      <div className="map-pipeline-popup-actions">
        <button type="button" className="map-pipeline-popup-btn primary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  )
}
